<template>
  <div style="padding-top: 3em;">
    <img src="/images/pae-logo.png" style="max-width: 140px; margin-bottom: 2em;" />

    <h4 class="title">Book Club Form</h4>
    <p>Please complete this request if you would like to join book club.</p>

    <br />

    <template v-if="message">
      <div class="notification is-primary">{{ message }}</div>
    </template>

    <form autocomplete="off" method="POST" @submit.prevent="onSubmit" v-if="!message">
      <input type="hidden" name="_token" :value="csrf" />
      <input type="hidden" v-model="form" />

      <div style="padding: 1em 0px; color: #aaa;">
        <small>* Required Fields</small>
      </div>

      <div class="columns is-multiline">
        <div class="column is-4">
          <div class="field">
            <label class="label">First Name *</label>
            <div class="control">
              <input autofocus type="text" placeholder="Please enter your first name"
                :class="{ 'input': true, 'is-danger': $v.firstname.$error }" @input="$v.firstname.$touch()"
                id="firstname" name="firstname" v-model="firstname" />
              <span v-if="$v.firstname.$error && !$v.firstname.required" class="help is-danger">
                First name is
                required
              </span>
              <span v-if="$v.firstname.$error && !$v.firstname.alpha" class="help is-danger">
                Invalid characters
                entered
              </span>
            </div>
          </div>
        </div>

        <div class="column is-4">
          <div class="field">
            <label class="label">Last Name *</label>
            <div class="control">
              <input type="text" placeholder="Please enter your last name"
                :class="{ 'input': true, 'is-danger': $v.lastname.$error }" @input="$v.lastname.$touch()" id="lastname"
                name="lastname" v-model="lastname" />
              <span v-if="$v.lastname.$error && !$v.lastname.required" class="help is-danger">
                Last name is
                required
              </span>
              <span v-if="$v.lastname.$error && !$v.lastname.alpha" class="help is-danger">
                Invalid characters
                entered
              </span>
            </div>
          </div>
        </div>

        <div class="column is-8">
          <div class="field">
            <label class="label">Email Address *</label>
            <div class="control">
              <input type="text" placeholder="Please enter your email"
                :class="{ 'input': true, 'is-danger': $v.emailaddress.$error }" id="emailaddress" name="emailaddress"
                v-model="emailaddress" @input="$v.emailaddress.$touch()" />
              <span v-if="$v.emailaddress.$error && !$v.emailaddress.required" class="help is-danger">
                Email is
                required
              </span>
              <span v-if="$v.emailaddress.$error && !$v.emailaddress.email" class="help is-danger">
                Format is
                incorrect
              </span>
            </div>
          </div>
        </div>

        <div class="column is-8">
          <div class="field">
            <label class="label">Contact Number *</label>
            <div class="control">
              <input type="text" placeholder="Please enter your contact number (eg. 84051234)"
                :class="{ 'input': true }" @input="$v.contactnumber.$touch()" id="contactnumber" name="contactnumber"
                v-model="contactnumber" />
              <span v-if="$v.contactnumber.$error && !$v.contactnumber.required" class="help is-danger">
                Contact number
                is required
              </span>
              <span v-if="$v.contactnumber.$error && !$v.contactnumber.numeric" class="help is-danger">
                Only numbers
                allowed
              </span>
            </div>
          </div>
        </div>

        <div class="column is-8">
          <div class="field">
            <label class="label">Library Card Number (if member)</label>
            <div class="control">
              <input type="text" placeholder="Please enter your library card number (eg. X012345785)"
                :class="{ 'input': true }" @input="$v.libraryCardNumber.$touch()" id="libraryCardNumber"
                name="libraryCardNumber" v-model="libraryCardNumber" />
              <span v-if="$v.libraryCardNumber.$error && !$v.libraryCardNumber.AlphNumCharsValidator"
                class="help is-danger">
                Invalid characters
              </span>
            </div>
          </div>
        </div>



        <div class="column is-8">
          <div class="field">
            <label class="label">Action: *</label>

            <div class="control">
              <div class="select">
                <select v-model="type">
                  <option value>-- Please choose from the following --</option>
                  <option value='join-group'>I am wanting to join a book club as an individual.</option>
                  <option value='new-group'>I am wanting to start up a new group.</option>
                  <option value='established-group'>I am part of an established group wanting to utilise the book group
                    collection.</option>
                </select>
              </div>
            </div>

          </div>
        </div>

        <template v-if="type == 'new-group'">
          <div class="column is-8">
            <div class="field">
              <label class="label">Specify Age Group: *</label>
              <div class="control">
                <input type="text" placeholder="Specify Age Group (eg. 40-60)" :class="{ 'input': true }"
                  @input="$v.ageGroup.$touch()" id="ageGroup" name="ageGroup" v-model="ageGroup" />
                <span v-if="$v.ageGroup.$error && !$v.ageGroup.required" class="help is-danger">
                  Age group is required
                </span>
              </div>
            </div>
            <div class="field">
              <label class="label">Name for New Group: *</label>
              <div class="control">
                <input type="text" placeholder="Please enter name for new group" :class="{ 'input': true }"
                  @input="$v.nameNewGroup.$touch()" id="nameNewGroup" name="nameNewGroup" v-model="nameNewGroup" />
                <span v-if="$v.nameNewGroup.$error && !$v.nameNewGroup.required" class="help is-danger">
                  Name is required
                </span>
              </div>
            </div>
          </div>
        </template>

        <template v-if="type == 'established-group'">
          <div class="column is-8">
            <div class="field">
              <label class="label">Name of Existing Group: *</label>
              <div class="control">
                <input type="text" placeholder="Please enter name of existing group" :class="{ 'input': true }"
                  @input="$v.nameExistingGroup.$touch()" id="nameExistingGroup" name="nameExistingGroup"
                  v-model="nameExistingGroup" />
                <span v-if="$v.nameExistingGroup.$error && !$v.nameExistingGroup.required" class="help is-danger">
                  Name is required
                </span>
              </div>
            </div>
          </div>
        </template>


        <div class="column is-8">
          <div class="field">
            <label class="label">Where is your closest library branch located? *</label>

            <div class="control">
              <div class="select">
                <select v-model="closestLibrary">
                  <option value>-- Select closest library location --</option>
                  <option>Enfield Library</option>
                  <option>Greenacres Library</option>
                  <option>Parks Library</option>
                  <option>Port Adelaide Library</option>
                  <option>Semaphore Library</option>
                </select>
              </div>
            </div>

          </div>
        </div>

        <div class="column is-8">
          <div class="field">
            <label class="label">If you want to start a group or are part of an established group, will the above
              contact details be the main point of contact? *</label>

            <div class="control">
              <div class="select">
                <select v-model="contactDetails">
                  <option value>-- Select --</option>
                  <option>Yes</option>
                  <option>No</option>
                </select>
              </div>
            </div>

          </div>
        </div>

        <template v-if="contactDetails == 'No'">
          <div class="column is-8">
            <div class="field">
              <label class="label">Contact Name: *</label>
              <div class="control">
                <input type="text" placeholder="Please enter contact name" :class="{ 'input': true }"
                  @input="$v.newContactName.$touch()" id="newContactName" name="newContactName"
                  v-model="newContactName" />
                <span v-if="$v.newContactName.$error && !$v.newContactName.required" class="help is-danger">
                  Contact Name is required
                </span>
              </div>
            </div>
            <div class="field">
              <label class="label">Contact Number: *</label>
              <div class="control">
                <input type="text" placeholder="Please enter contact number" :class="{ 'input': true }"
                  @input="$v.newContactNumber.$touch()" id="newContactNumber" name="newContactNumber"
                  v-model="newContactNumber" />
                <span v-if="$v.newContactNumber.$error && !$v.newContactNumber.required" class="help is-danger">
                  Name is required
                </span>
              </div>
            </div>
          </div>
        </template>






        <div class="column is-8" v-if="enableGoogleCaptch">
          <div class="field">
            <vue-recaptcha ref="invisibleRecaptcha" @verify="onVerify" @expired="onExpired" size="invisible"
              :sitekey="googleCaptchaKey"></vue-recaptcha>
          </div>
        </div>

        <div class="modal" v-bind:class="{'is-active' : loading}">
          <div class="modal-background"></div>
          <div class="modal-content has-text-centered">
            <h1 class="title is-3 has-text-light">Please wait...</h1>
            <button class="button is-info is-loading is-fullwidth is-large"
              style="font-size: 5em; background: transparent;">Submitting</button>
          </div>
        </div>

        <div class="column is-8">
          <div class="field is-grouped">
            <div class="control">
              <button class="button is-link is-primary">Submit</button>
            </div>
            <div class="control">
              <button class="button is-text" @click.prevent="clear">Clear</button>
            </div>
          </div>
        </div>

      </div>
    </form>
  </div>
</template>
<script>
  import VueRecaptcha from "vue-recaptcha";

import PropertyAddress from "../../../../../../resources/assets/js/components/address/Typeahead-CouncilAddress.vue";

import {
  alpha,
  required,
  requiredIf,
  email,
  numeric,
  alphaNum,
  minValue,
  minLength,
} from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import moment from "moment";

// Custom Validators
import { AlphNumCharsValidator } from "../../../../../../resources/assets/js/validators/alpha-num-chars-validator";

export default {
  components: {
    PropertyAddress,
    VueRecaptcha,
  },

  props: {
    form: {},
  },

  data() {
    return {
      googleCaptchaKey: "6LcyrE0UAAAAAExxoj3NBm1vA-WMu88CIigyzkBU",
      enableGoogleCaptch: false,

      csrf: "",
      formTitle: this.form,
      message: "",
      submitted: false,
      loading: false,

      fileIDs: [],

      // FORM DATA
      code: "",
      firstname: "",
      lastname: "",
      contactnumber: "",
      emailaddress: "",
      libraryCardNumber: "",
      type: "",
      ageGroup: "",
      nameNewGroup: "",
      nameExistingGroup: "",
      closestLibrary: "",
      contactDetails: "",
      newContactName: "",
      newContactNumber: ""
    };
  },

  validations: {
    firstname: { required, alpha },
    lastname: { required, alpha },
    emailaddress: { required, email },
    contactnumber: { required, numeric },
    libraryCardNumber: { AlphNumCharsValidator },
    type: { required },
    ageGroup: { 
      required: requiredIf(function () {
        return this.type == 'new-group';
      }),
    },
    nameNewGroup: { 
      required: requiredIf(function () {
        return this.type == 'new-group';
      }),     
    },
    nameExistingGroup: { 
      required: requiredIf(function () {
        return this.type == 'established-group';
      }),            
    },
    closestLibrary: { required },
    contactDetails: { required },
    newContactName: { 
      required: requiredIf(function () {
        return this.contactDetails == 'No';
      }),
    },
    newContactNumber: { 
      required: requiredIf(function () {
        return this.contactDetails == 'No';
      }),      
    },
    form: [
      "firstname",
      "lastname",
      "emailaddress",
      "contactnumber",
      "libraryCardNumber",
      "type",
      "ageGroup",
      "nameNewGroup",
      "nameExistingGroup",
      "closestLibrary",
      "contactDetails",
      "newContactName",
      "newContactNumber"
    ],
  },

  watch: {},

  computed: {
    fullName: function () {
      return this.firstname + " " + this.lastname;
    },
    precis: function () {
      return (
        "Book Club Form - " +
        (this.fullName + this.libraryCardNumber > '' ? " - " + this.libraryCardNumber : "")
      );
    },

    formData: function () {
      var fields = {};
      fields.firstName = this.firstname;
      fields.lastName = this.lastname;
      fields.emailAddress = this.emailaddress;
      fields.contactNumber = this.contactnumber;
      fields.libraryCardNumber = this.libraryCardNumber;
      fields.type = this.type;
      fields.ageGroup = this.ageGroup,
      fields.nameNewGroup = this.nameNewGroup,
      fields.nameExistingGroup = this.nameExistingGroup,
      fields.closestLibrary = this.closestLibrary;
      fields.contactDetails = this.contactDetails;
      fields.newContactName = this.newContactName;
      fields.newContactNumber = this.newContactNumber;

      fields.precis = this.precis;
      fields.subject = "17.90.2.9";

      return JSON.stringify(fields);
    },
  },

  methods: {

    validate() {
      console.log("validate");
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },

    onSubmit() {
      console.log("submit");
      if (this.validate()) {
        console.log("valid");
        if (this.enableGoogleCaptch) {
          this.$refs.invisibleRecaptcha.execute();
          console.log("1");
        } else {
          console.log("2");
          this.submitForm();
          console.log("3");
        }
      }
    },

    submitForm() {
      this.loading = true;
      axios
        .post("/onlineform/" + this.form, {
          _token: this.csrf,
          formTitle: this.formTitle,
          fullName: this.fullName,
          emailAddress: this.emailaddress,
          contactNumber: this.contactnumber,
          precis: this.precis,
          formData: this.formData,
          message: "",
        })
        .then((response) => {
          // console.log(response.data.message);
          this.message = response.data.message;
          this.clear();
          //this.submitted = true
          setTimeout(() => (this.submitted = true), 5000);
          this.loading = false;
        });
    },

    onVerify: function (response) {
      if (response) {
        axios
          .post("/api/recaptchaSiteVerify", {
            value: response,
          })
          .then((gresponse) => {
            // console.log(gresponse);

            if (gresponse["data"] === "valid") {
              this.submitForm();
            } else {
              this.loading = false;
              this.message = "Failed verify google captcha!";
              console.log("Failed verify google captcha!");
            }
          })
          .catch((error) => {
            console.log(error.response.data);
          });
      } else {
        alert("Failed captcha");
      }
    },
    onExpired: function () {
      console.log("Expired");
    },

    onSuccess(response) {},

    clear() {},
  },

  mounted() {
    this.csrf = window.laravel.csrfToken;
  },
};
</script>


// WEBPACK FOOTER //
// Modules/OnlineForm/Resources/assets/js/components/LayoutBookClub.vue